import React from 'react';

/** Inline loader — keeps header/footer visible during route changes */
const RouteContentLoader = () => (
  <div
    className="min-h-[50vh] flex flex-col items-center justify-center w-full"
    role="status"
    aria-live="polite"
    aria-label="Loading page"
  >
    <div className="relative w-12 h-12" aria-hidden="true">
      <div className="absolute inset-0 rounded-full border-4 border-orange-500/20" />
      <div className="absolute inset-0 rounded-full border-4 border-t-orange-500 border-r-transparent animate-spin" />
    </div>
    <p className="mt-3 text-sm text-white/50">Loading…</p>
  </div>
);

export default RouteContentLoader;
